<template>
    <button v-if="clickHandler" :disabled="formSubmitting" :type="type" @click="clickHandler" :class="btnClasses">
        <template v-if="!formSubmitting">
            {{ content }}
        </template>
        <template v-else>
            <div class="loader">
                <loader :width="15" :height="15"/>
            </div>
        </template>
    </button>
    <button v-else :disabled="formSubmitting" :type="type" :class="btnClasses">
        <template v-if="!formSubmitting">
            {{ content }}
        </template>
        <template v-else>
            <div class="loader">
                <loader :width="15" :height="15"/>
            </div>
        </template>
    </button>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'LoaderedButton',
    props: {
        content: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'button'
        },
        btnClasses: {
            type: String,
            default: ''
        },
        clickHandler: {
            type: Function
        },
        isValid: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState(['formSubmitting'])
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LoaderedButton.vue